import { render } from "./ReviewCreate.vue?vue&type=template&id=5c229c98&scoped=true"
import script from "./ReviewCreate.vue?vue&type=script&lang=js"
export * from "./ReviewCreate.vue?vue&type=script&lang=js"

import "./ReviewCreate.vue?vue&type=style&index=0&id=5c229c98&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/movie-night/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c229c98"]])

export default __exports__